var getNative=require("./_getNative"),root=require("./_root"),Promise=getNative(root,"Promise");module.exports=Promise;